"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Superscript_1 = __importDefault(require("./styledComponents/Superscript"));

var Separator_1 = __importDefault(require("./styledComponents/Separator"));

var Text_1 = __importDefault(require("./styledComponents/Text"));

var Disclaimer_meta_1 = require("./Disclaimer.meta");

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var Disclaimer =
/** @class */
function (_super) {
  __extends(Disclaimer, _super);

  function Disclaimer(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Disclaimer_meta_1.DISCLAIMER_CATEGORY_KEY;
    _this.componentKey = Disclaimer_meta_1.DISCLAIMER_COMPONENT_KEY;
    return _this;
  }

  Disclaimer.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        text = _a.text,
        hasHtmlContent = _a.hasHtmlContent,
        superscript = _a.superscript,
        separator = _a.separator,
        isInline = _a.isInline,
        useSeparator = _a.useSeparator;

    if (ksys_app_template_1.utils.typeChecks.isNullOrUndefined(text)) {
      return null;
    }

    var wrapperStyle = {};

    if (isInline) {
      wrapperStyle.display = 'inline';
    }

    return react_1.default.createElement(Wrapper_1.default, {
      className: className,
      style: wrapperStyle
    }, superscript && react_1.default.createElement(Superscript_1.default, null, superscript), hasHtmlContent !== false ? react_1.default.createElement(Text_1.default, {
      dangerouslySetInnerHTML: {
        __html: text
      }
    }) : react_1.default.createElement(Text_1.default, null, text), useSeparator && separator && react_1.default.createElement(Separator_1.default, null, separator));
  };

  Disclaimer = __decorate([mobx_react_1.observer], Disclaimer);
  return Disclaimer;
}(shared_1.ComponentBase);

exports.Disclaimer = Disclaimer;
exports.default = shared_1.InjectedStyledComponent(Disclaimer, Disclaimer_meta_1.DISCLAIMER_CATEGORY_KEY, Disclaimer_meta_1.DISCLAIMER_COMPONENT_KEY);